import './skeletonAlertTable.scss';

const SkeletonAlertTable = () => {
    return (
        <div className="envio-detalle-modal w-100 d-flex flex-column align-items-end content-table skeleton-alert-table">
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th colSpan={2}>#</th>
                            <th className="text-center" colSpan={2}>
                                fecha
                            </th>
                            <th className="text-center" colSpan={2}>
                                remitente
                            </th>
                            <th className="text-center" colSpan={2}>
                                destinatario
                            </th>
                            <th className="text-center" colSpan={3}>
                                pieza
                            </th>
                            <th className="text-center" colSpan={2}>
                                transportista
                            </th>
                            <th className="text-center" colSpan={3}>
                                servicio
                            </th>
                            <th className="text-center" colSpan={2}>
                                estado
                            </th>
                            <th className="text-center" colSpan={2}>
                                resp
                            </th>
                            <th className="text-center" colSpan={1}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: 7 }).map((envio, i) => (
                            <tr key={i}>
                                <td colSpan={2}>
                                    <span className="skeleton skeleton--small"></span>
                                </td>
                                <td className="text-center" colSpan={2}>
                                    <span className="skeleton skeleton--medium"></span>
                                </td>
                                <td colSpan={2}>
                                    <div className="d-flex flex-column">
                                        <span className="skeleton skeleton--small"></span>
                                        <span className="skeleton skeleton--small"></span>
                                    </div>
                                </td>
                                <td colSpan={2}>
                                    <div className="d-flex flex-column">
                                        <span className="skeleton skeleton--medium"></span>
                                        <span className="skeleton skeleton--small"></span>
                                    </div>
                                </td>
                                <td colSpan={3}>
                                    <span className="skeleton skeleton--large"></span>
                                </td>
                                <td className="text-center" colSpan={2}>
                                    <span className="skeleton skeleton--small"></span>
                                </td>
                                <td className="text-center" colSpan={3}>
                                    <div className="d-flex flex-column">
                                        <span className="skeleton skeleton--small"></span>
                                        <span className="skeleton skeleton--medium"></span>
                                    </div>
                                </td>
                                <td
                                    className="text-center text-uppercase"
                                    colSpan={2}
                                >
                                    <span className="skeleton skeleton--small"></span>
                                </td>
                                <td
                                    className="text-center text-uppercase"
                                    colSpan={2}
                                >
                                    <span className="skeleton skeleton--small"></span>
                                </td>
                                <td className="text-center" colSpan={1}>
                                    <span className="skeleton skeleton--xs"></span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SkeletonAlertTable;
